import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { PortfolioService } from '../shared/services/portfolio.service';
import { PortfolioModel } from '../shared/models/portfolio-model';
import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'hr-portfolio-view',
  templateUrl: './portfolio-view.component.html',
  styleUrls: ['./portfolio-view.component.less'],
  standalone: false,
})
export class PortfolioViewComponent implements OnInit, OnDestroy {
  constructor(
    private portfolioService: PortfolioService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  public portfolioId: any;
  private sub: Subscription;
  public portfolio: PortfolioModel;
  public displayViewHistory: boolean;

  public onEditAccountManagerClick(isInEditMode: boolean) {
    isInEditMode = true;
  }

  public onEditPortfolioNameClick(isInEditMode: boolean) {
    isInEditMode = true;
  }

  public onUpdatePortfolioNameClick(portfolio: PortfolioModel) {
    this.portfolioService
      .getPortfolio(portfolio.portfolioId)
      .subscribe((d) => (this.portfolio = d));
  }

  public onPortfolioAccountManagerUpdated(portfolio: PortfolioModel) {
    this.portfolioService
      .getPortfolio(portfolio.portfolioId)
      .subscribe((d) => (this.portfolio = d));
  }

  public onPortfolioViewHistoryClick(display: boolean) {
    this.displayViewHistory = display;
  }

  public onCloseViewHistoryClick(display: boolean) {
    this.displayViewHistory = display;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe((p) => {
      let portfolioId = +p['id'];
      this.portfolioId = portfolioId;
      this.portfolioService
        .getPortfolio(portfolioId)
        .subscribe((d) => (this.portfolio = d));
    });
  }
}
